<script setup>
import AppIcon from "./AppIcon.vue";

const props = defineProps({
  color: {
    type: String,
    required: true,
    validator: (value) => ["red", "blue", "green", "plain", "plain-selected"].includes(value),
  },
  size: {
    type: String,
    required: true,
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
  label: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    required: false,
    default: '',
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const nomin = props.label ? "" : "nomin";

const emit = defineEmits(["click"]);

function handleClick() {
  if (!props.disabled) emit("click");
}
</script>

<template>
  <button
    @click="handleClick"
    :class="['ui-button', `ui-button-${color}`, `ui-button-${size}`, nomin]"
    :disabled="disabled"
    :title="tooltip"
  >
    <span v-if="label">{{ label }}</span>
    <AppIcon :name="icon" />
  </button>
</template>
